<template>
  <v-text-field
    color="primary"
    class="suus__text-field"
    :placeholder="placeholder"
    filled
    persistent-placeholder
    v-model="textFieldValue"
    background-color="lightGrey"
    :autofocus="autofocus"
    :required="required"
    :hide-details="hideDetails"
    :disabled="disabled"
    @blur="$emit('blur')"
  >
    <template v-slot:label>
      <span :style="labelStyles(disabled)">{{ label }}</span>
      <span class="suus__text-field-mandatory" v-if="required">*</span>
    </template>
    <template v-slot:append>
      <v-btn
        v-if="buttonText && !hideButton"
        class="suus__text-field-button"
        color="secondary"
        small
        @click="$emit('buttonClick')"
        >{{ buttonText }}</v-btn
      >
    </template>
  </v-text-field>
</template>

<script lang="ts">
import { computed, defineComponent, WritableComputedRef } from "vue"
import theme from "constants/theme"

/**
 *  SHOULD BE DEPRECATED PROBABLY; USE INPUTFIELD INSTEAD
 *  TODO: Remove this component by replacing it with the InputField component
 *  and decoupling TitleTextField.vue and ToggableTextField.vue
 */

export default defineComponent({
  name: "SuusTextField",
  props: {
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    buttonText: {
      type: String,
      required: false,
      default: null,
    },
    value: {
      type: String,
      required: false,
      default: "",
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    labelStyles(disabled = false): Partial<CSSStyleDeclaration> {
      return {
        color: this.primaryColor,
        fontWeight: "400",
        opacity: disabled ? "0.5" : "1.0",
      }
    },
  },
  setup(props, { emit }) {
    const primaryColor = theme.colors.light.primary

    const textFieldValue: WritableComputedRef<string> = computed({
      get: () => props.value,
      set: (value: string) => emit("input", value),
    })

    return {
      textFieldValue,
      primaryColor,
    }
  },
})
</script>

<style lang="sass">
%font-stack
  font-family: "system-ui" !important
  font-size: 1.2rem !important
  font-weight: 300
.suus__text-field
  @extend %font-stack
  .v-input__slot
    .v-text-field__slot
      input
        margin-top: 24px !important
        @extend %font-stack
.suus__text-field-mandatory
  color: red
  font-weight: 400
.suus__text-field-button
  font-family: "system-ui" !important
  font-weight: 900
</style>
